import { Route, Routes } from 'react-router-dom';
import Login from './features/auth/Login';
import { NotFound } from './pages/NotFound';
import Home from './pages/home/Home';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} index />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
